import currentWidgetDetails from "utilities/platform/widget-details";
import * as constants from "utilities/global/sparta-mediaquery-constants-utility/1.1.0/js/constants";
import MediaQueryListModel from "utilities/global/sparta-mediaquery-constants-utility/1.1.0/js/MediaQueryListModel";




const mediaQueriesList = [
  new MediaQueryListModel(constants.mediaQueryViewportString, constants.viewportNames.small, constants.smallMediaQueryString, constants.smallMinWidth),
  new MediaQueryListModel(constants.mediaQueryViewportString, constants.viewportNames.medium, constants.mediumMediaQueryString, constants.mediumMinWidth),
  new MediaQueryListModel(constants.mediaQueryViewportString, constants.viewportNames.large, constants.largeMediaQueryString, constants.largeMinWidth),
  new MediaQueryListModel(constants.mediaQueryViewportString, constants.viewportNames.largeCentered, constants.largeCenteredMediaQueryString, constants.largeCenteredMinWidth),
  new MediaQueryListModel(constants.mediaQueryViewportString, constants.viewportNames.xlarge, constants.xlargeMediaQueryString, constants.xlargeMinWidth),
  new MediaQueryListModel(constants.mediaQueryViewportString, constants.viewportNames.xxlarge, constants.xxlargeMediaQueryString, constants.xxlargeMinWidth),
  new MediaQueryListModel(constants.mediaQueryOrientationString, constants.landscapeOrientationName, constants.landscapeMediaQueryString),
  new MediaQueryListModel(constants.mediaQueryOrientationString, constants.portraitOrientationName, constants.portraitMediaQueryString),
  new MediaQueryListModel(constants.mediaQueryResolutionString, constants.defaultResolutionName, constants.defaultResolutionMediaQueryString),
  new MediaQueryListModel(constants.mediaQueryResolutionString, constants.retinaResolutionName, constants.retinaResolutionMediaQueryString),
];

export default {
  mediaQueriesList,
  constants,
  MediaQueryListModel,
};
